import { Component } from "preact";

export class ErrorBoundary extends Component {
  state = { hasError: false, error: null as Error | null };

  componentDidCatch(error: Error) {
    this.setState({ hasError: true, error });
    console.error("ErrorBoundary caught:", error);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div class="d-flex flex-column align-items-center justify-content-center vh-100 p-4 text-center">
          <h1 class="h3 mb-3">Something went wrong</h1>
          <p class="text-muted mb-4">
            {this.state.error?.message || "An unexpected error occurred."}
          </p>
          <button
            type="button"
            class="btn btn-primary"
            onClick={() => window.location.reload()}
          >
            Refresh page
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
